import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { CalculationResultStatus, VersicherungspraemieCalculationResultDto } from '@backend/models';

@Component({
  selector: 'app-calculation-error-display',
  imports: [
    TranslocoPipe
  ],
  templateUrl: './calculation-error-display.component.html',
  styleUrl: './calculation-error-display.component.scss'
})
export class CalculationErrorDisplayComponent {

  @Input() result!: VersicherungspraemieCalculationResultDto | null;

  protected readonly CalculationResultStatus = CalculationResultStatus;
}
